import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  MFTemplateSelectedIds: [],
  MFTemplateTreeData: [],
  MFTemplateAppliedData: [],
  MFTemplateSearchQuery: "",
  MFTemplateExpandedItems: [],
};

const MFTemplateTreeSlice = createSlice({
  name: "MFTemplateTree",
  initialState,
  reducers: {
    setMFTemplateSelectedIds: (state, action) => {
      state.MFTemplateSelectedIds = action.payload;
    },
    setMFTemplateTreeData: (state, action) => {
      state.MFTemplateTreeData = action.payload;
    },
    setMFTemplateAppliedData: (state, action) => {
      state.MFTemplateAppliedData = action.payload;
    },
    setMFTemplateSearchQuery: (state, action) => {
      state.MFTemplateSearchQuery = action.payload;
    },
    resetMFTemplateSelection: (state) => {
      state.MFTemplateSelectedIds = [];
      state.MFTemplateAppliedData = [];
    },
    setMFTemplateExpandedItems: (state, action) => {
      state.MFTemplateExpandedItems = action.payload;
    },
  },
});

export const {
  setMFTemplateSelectedIds,
  setMFTemplateTreeData,
  setMFTemplateAppliedData,
  setMFTemplateSearchQuery,
  resetMFTemplateSelection,
  setMFTemplateExpandedItems,
} = MFTemplateTreeSlice.actions;

export default MFTemplateTreeSlice.reducer;